angular.module('unica_auth.auth_services')

.factory('LoginService', function ($http, getBaseApiURL, Session) {

	var loginService = {};

	// Send Login Request, if ok, create the Session
	loginService.login = function (credentials)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/login',
			data: credentials,
			withCredentials: true
		}).then(function(result) {
			if (result && result.data) {
				// console.log(result);
				// Se MFA richiesto, backend risponde con {mfa_required: true, user_id: ...}
				if (result.data.mfa_required) {
					return {
						mfa_required: true,
						user_id: result.data.user_id
					};
				} else if (result.data.mfa_setup_required) {
					return {
						mfa_setup_required: true,
						user_id: result.data.user_id
					};
				}

				return result.data.user;
			}
		});
	};

	// Step 2: verifica TOTP
	loginService.verifyTotp = function (data) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/verify-totp',
			data: data,
			withCredentials: true
		}).then(function(result) {
			if (result && result.data && result.data.user) {
				return result.data.user;
			}
			return null;
		});
	};


	// Send Login Request, if ok, create the Session
	loginService.checkNAM = function ( token )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/check-nam',
			data: { token },
			headers: {
				Authorization : 'Bearer ' + token,
				Accept: 'application/json'
			}
		}).then(function(result) {
			if ( result ) {
				// Session.create(
				// 	result.data.token,
				// 	result.data.user.id,
				// 	result.data.user.fiscal_code,
				// 	result.data.user.first_name,
				// 	result.data.user.last_name,
				// 	result.data.user.role,
				// 	result.data.user.sub_role,
				// 	result.data.user.manager_media_permission
				// );

				return result.data.user;
			}

		});
	};

	// Step onboarding: genera secret e QR code
	loginService.mfaSetup = function (data) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/mfa-setup',
			data: data,
			withCredentials: true
		}).then(function(result) {
			if (result && result.data) {
				// console.log(result.data);
				return {
					secret: result.data.secret,
					qr_svg: result.data.qr_svg
				};
			}
			return null;
		});
	};

	// Step onboarding: attiva MFA
	loginService.activateMfa = function (data) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/activate-mfa',
			data: data,
			withCredentials: true
		}).then(function(result) {
			if (result && result.data && result.data.user) {
				return result.data.user;
			}
			return null;
		});
	};

	return loginService;
});